import React from 'react';
import styled from 'styled-components';
import { device, SCREENSIZES } from '../../constants';

interface DivProps extends React.HTMLProps<HTMLDivElement> {}

export const Box: React.FC<DivProps> = ({ children, ...props }) => {
  return <BoxStyle {...props}>{children}</BoxStyle>;
};

const BoxStyle = styled.div`
  max-width: ${SCREENSIZES.MAX_WIDTH}px;
  margin: auto;
  padding: 0 20px;
  @media screen and ${device.sm} {
    padding: 0 10px;
  }
`;
